import { Card, CardContent, Divider } from '@mui/material'
import { Button } from '@/@core/components/mui/Button'
import { useQuery } from '@tanstack/react-query'
import { useRouteQuery } from '@/hooks/useRouteQuery'
import { Attendances } from '@/@data'
import FilterMonthAttendance from '@/components/attendance/detail-attendance/FillterMonthAttendance'
import dayjs from 'dayjs'
import { AttendanceEmployeeTotal } from '@/components/attendance/employee/AttendanceEmployeeTotal'
import { AttendanceEmployeeTable } from '@/components/attendance/tables/AttendanceEmployeeTable'
import { useNavigate } from 'react-router-dom'

export const AttendanceEmployees = ({ employee }: { employee: any }) => {
  const { __, __n } = useTranslator()
  const { searchQuery, updateQuery } = useRouteQuery()
  const { id } = useParams()
  const navigate = useNavigate()

  const paramsCompany = useMemo(() => {
    return {
      companyId: Number(employee?.company_id),
      month: searchQuery.get('month')
    }
  }, [searchQuery.get('month'), employee?.company_id])

  const paramsEmployee = {
    companyId: Number(employee?.company_id),
    userId: id,
    month: searchQuery.get('month')
  }

  const { data: dataCompany } = useQuery({
    ...Attendances.getAttendanceDetailByCompanyId(paramsCompany),
    enabled: !!searchQuery.get('month') && !!employee?.company_id
  })

  const paramsCompanyBeforeMonth = {
    companyId: Number(employee?.company_id),
    month: dayjs(searchQuery.get('month')).subtract(1, 'month').format('YYYY-MM-DD')
  }

  const { data: dataCompanyBeforeMonth } = useQuery({
    ...Attendances.getAttendanceDetailByCompanyId(paramsCompanyBeforeMonth),
    enabled: !!employee?.company_id && !!dayjs(searchQuery.get('month')).subtract(1, 'month').format('YYYY-MM-DD')
  })

  const currentMonthDisplay = useMemo(() => {
    const monthParam = searchQuery.get('month')

    if (monthParam) {
      return dayjs(monthParam).format('MMMM YYYY')
    }

    return dayjs().format('MMMM YYYY')
  }, [searchQuery.get('month')])

  const { data: dataEmployee } = useQuery({
    ...Attendances.getAttendanceDetailByCompanyIdEmployee(paramsEmployee),
    enabled: !!id && !!searchQuery.get('month') && !!employee?.company_id
  })

  return (
    <div>
      <Card className='shadow-none rounded-[32px]'>
        <CardContent sx={{ padding: 0 }} className='p-0'>
          <div className='flex justify-between items-center p-5'>
            <div className='text-[18px] font-medium text-[#2f2b3d]'>{__('Defaut Attendance/Payroll')}</div>
            <Button
              variant='outlined'
              size='small'
              startIcon={<i className='tabler-calendar-event'></i>}
              className='border-blue-500 text-blue-600 hover:border-blue-600'
              onClick={() => {
                navigate(
                  `/cms/attendance/employee/${id}?month=${searchQuery.get('month')}&companyId=${employee?.company_id}`
                )
              }}
            >
              <span className='text-[15px] font-medium'>{__('Attendance Management')}</span>
            </Button>
          </div>
          <div className='px-5'>
            <Divider />
          </div>
          <div className='p-5'>
            <FilterMonthAttendance
              onDateChange={month => {
                updateQuery({ month })
              }}
              isShowSettingDay={true}
              data={dataCompany?.data || {}}
              currentPayPeriod={dataCompany?.data?.current_pay_period}
              status={dataCompany?.data?.status || ''}
              isDisablePreviousMonth={!dataCompanyBeforeMonth}
            />
          </div>
          <Divider />
          <div className='p-5'>
            <div className='flex items-center gap-2 justify-between border-b border-[#2f2b3d1f] pb-2'>
              <div className='text-[18px] font-medium text-[#2f2b3d]'>
                {__('Payroll')} {currentMonthDisplay}
              </div>
            </div>
            <div className='grid grid-cols-4 gap-x-3 gap-y-5 mt-3'>
              <div className='flex items-start gap-2'>
                <div>
                  <img src='/images/icons/gross_pay.png' alt='avatar' className='w-[40px] h-[40px]' />
                </div>
                <div>
                  <div className='text-[18px] font-medium text-[#2f2b3de6]'>
                    {__n(dataEmployee?.data?.data?.gross_pay)}
                  </div>
                  <div className='text-[13px] font-normal text-[#2f2b3db3]'>{__('Gross Pay')}</div>
                </div>
              </div>
              <div className='flex items-start gap-2'>
                <div>
                  <img src='/images/icons/net_pay.png' alt='avatar' className='w-[40px] h-[40px]' />
                </div>
                <div>
                  <div className='text-[18px] font-medium text-[#2f2b3de6]'>
                    {__n(dataEmployee?.data?.data?.net_pay)}
                  </div>
                  <div className='text-[13px] font-normal text-[#2f2b3db3]'>{__('Net Pay')}</div>
                </div>
              </div>
              <div className='flex items-start gap-2'>
                <div>
                  <img src='/images/icons/daily_wage.png' alt='avatar' className='w-[40px] h-[40px]' />
                </div>
                <div>
                  <div className='text-[18px] font-medium text-[#2f2b3de6]'>
                    {__n(dataEmployee?.data?.data?.daily_wage)}
                  </div>
                  <div className='text-[13px] font-normal text-[#2f2b3db3]'>{__('Daily Wage')}</div>
                </div>
              </div>
            </div>
          </div>
          <Divider />
          <AttendanceEmployeeTotal dataEmployee={dataEmployee || {}} />
          <AttendanceEmployeeTable
            data={dataEmployee?.data?.data || []}
            minimum_working_days={dataCompany?.data?.minimum_working_days}
            withdraw_cutoff_day={dataCompany?.data?.company?.withdraw_cutoff_day}
          />
        </CardContent>
      </Card>
    </div>
  )
}
